import AutoComplete from "autocomplete-js";

export default class AutoCompleteApi {
    newNoResult;
    searchInput;
    constructor() {

        this.searchInput = document.querySelector('.uk-search-input');
        if (this.searchInput) {
            this.newNoResult = this.searchInput.getAttribute("data-autocomplete-no-result");
            new AutoComplete({
                QueryArg: "query",
                Delay: 0,
                EmptyMessage: this.newNoResult,
            });
        }
    }
}
